import React from 'react';

import { TabsList, TabsTrigger } from '@/components/ui/tabs';
import { CALENDAR_VIEWS } from '../../../constants';

const ViewToggle = () => (
  <TabsList>
    {Object.values(CALENDAR_VIEWS).map(({ label, value }) => (
      <TabsTrigger key={value} value={value}>
        {label}
      </TabsTrigger>
    ))}
  </TabsList>
);

export default ViewToggle;
